export function formatMessageData(
    conversationId,
    userId,
    content,
    position,
    content_type = "normal",
    dateTime
) {
    const formattedDateTime = dateTime
        ? new Date(dateTime).toISOString()
        : new Date().toISOString();

    return {
        conversation_id: conversationId,
        user_id: userId,
        content_type: content_type,
        content: content,
        position: position,
        created_at: formattedDateTime,
    };
}

export function formatAmount(amount) {
    const formattedAmount = Number(amount).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return formattedAmount;
}

export function normalizeHistoryTimestampToUTC(iso) {
    if (!iso) return new Date().toISOString();

    // Trim microseconds to milliseconds if any
    let s = iso.replace(/\.(\d{3})\d+([Z]|[+\-]\d{2}:\d{2})$/, ".$1$2");

    // Build client’s local offset like +08:00 / -05:00
    const offsetMin = -new Date().getTimezoneOffset(); // MYT => 480
    const sign = offsetMin >= 0 ? "+" : "-";
    const pad2 = (n) => String(Math.floor(Math.abs(n))).padStart(2, "0");
    const hh = pad2(Math.trunc(offsetMin / 60));
    const mm = pad2(offsetMin % 60);
    const localOffset = `${sign}${hh}:${mm}`;

    // If it ends with Z (but actually local), reinterpret as local by swapping Z → +HH:MM
    if (s.endsWith("Z")) {
        s = s.slice(0, -1) + localOffset; // "…Z" -> "…+08:00"
    }

    // Now parse with the correct offset and output true UTC (Z)
    const d = new Date(s);
    return isNaN(d.getTime()) ? new Date().toISOString() : d.toISOString();
}
export const formatHistoryChatdata = (data, userId) => {
    if (data === null) {
        return [];
    } else {
        const formatData = data.flatMap((v, i) => {
            const formattedDateTime = v.created_at
                ? normalizeHistoryTimestampToUTC(v.created_at)
                : new Date().toISOString();
            const messages = [
                {
                    conversation_id: userId,
                    user_id: "user",
                    content_type: "normal",
                    content: v.question,
                    position: i + 1,
                    created_at: formattedDateTime,
                },
                {
                    conversation_id: userId,
                    user_id: "bot",
                    content_type: "normal",
                    content: v.answer,
                    position: i + 1,
                    created_at: formattedDateTime,
                    rate_disabled: true,
                },
            ];

            return messages;
        });

        return formatData;
    }
};

export function formatMessageDataV2(
    conversationId,
    userId,
    content,
    position,
    rate,
    content_type = "normal",
    dateTime
) {
    const formattedDateTime = dateTime
        ? new Date(dateTime).toISOString()
        : new Date().toISOString();

    return {
        conversation_id: conversationId,
        user_id: userId,
        content_type: content_type,
        content: content,
        position: position,
        created_at: formattedDateTime,
        rate_disabled: rate,
    };
}

export const formatDataMinimizeChat = (messages, rateMessageData) => {
    const updatedMessages = messages.map((msg) => {
        const rateEntry = rateMessageData.find(
            (min) => min.id === msg.conversation_id
        );

        if (rateEntry) {
            return {
                ...msg,
                rate: rateEntry.rate,
            };
        }

        return msg;
    });

    return updatedMessages;
};
